<lazy-echart *ngIf="options" class="chart" [class.chart--fixed-height]="hasFixedHeight"
    [options]="options"
></lazy-echart>